import { Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { WebPushSubscriptionStatus } from '../../enums/web-push-subscription-status.enum';
import { LogService } from '../log/log.service';
import { MainHttpService } from '../mainHttp/main-http.service';

@Injectable({
    providedIn: 'root'
})
export class WebPushService {
    public status = WebPushSubscriptionStatus.NotSubscribed;

    private readonly VAPID_PUBLIC_KEY = 'BKye-5pAeL-kplvKqUc6XmTq8_YY7ddcb1ILG9wdtZNRBALAdfftrDY_uPKhY6J7YF_NXY64uWyGcNEPr-bL4MM';
    private sub: PushSubscription;

    constructor(
        private logger: LogService,
        private swPush: SwPush,
        private httpService: MainHttpService
    ) {
    }

    public subscribe() {
        if (!this.swPush.isEnabled) {
            this.status = WebPushSubscriptionStatus.Unsupported;
            return;
        }

        this.swPush.requestSubscription({
            serverPublicKey: this.VAPID_PUBLIC_KEY
        })
            .then(sub => {

                this.sub = sub;

                this.logger.log('Notification Subscription: ', sub);

                this.httpService
                    .post('webpush/subscribe', sub)
                    .subscribe(
                        () => {
                            this.logger.log('Sent push subscription object to server.');
                            this.swPush.messages.subscribe(msg => this.logger.log(msg));

                            this.status = WebPushSubscriptionStatus.Subscribed;
                        },
                        err => {
                            this.logger.log('Could not send subscription object to server, reason: ', err);
                        });

            })
            .catch(err => {
                this.logger.error('Could not subscribe to notifications', err);
                this.status = WebPushSubscriptionStatus.Unsupported;
            });

        this.swPush.notificationClicks.subscribe(event => {
            this.logger.log(event);
        });
    }
}
